import Vue from 'vue';
import store from './../../store';
import adjustmentTransformer from './../../transformers/adjustment';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const adjustments = adjustmentTransformer.fetchCollection(data.data);

  store.dispatch('FetchAllAdjustments', adjustments);
  resolve(adjustments);
};

const failed = () => {
};

export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/adjustments', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/adjustment/all.js